import React from 'react';
import classNames from 'classnames';
import Base from 'antd/es/typography/Base';
import warning from 'antd/es/_util/warning';
import { ConfigContext } from '../config-provider';
import { tupleNum } from 'antd/es/_util/type';
import AntdConfigProvider from 'antd/es/config-provider';
const SUBTITLE_LEVEL_LIST = tupleNum(1, 2);
const Subtitle = (props) => {
    const { getPrefixCls, ...restContext } = React.useContext(ConfigContext);
    const { level = 1, className: customizeClassName, prefixCls: customizePrefixCls, ...otherProps } = props;
    const prefixCls = getPrefixCls('typography', customizePrefixCls);
    if (SUBTITLE_LEVEL_LIST.indexOf(level) === -1) {
        if (process.env.NODE_ENV !== 'production')
            warning(false, 'Typography.Subtitle', 'Subtitle only accept `1 | 2 ');
    }
    const className = classNames(`${prefixCls}-subtitle-${level}`, customizeClassName);
    return (React.createElement(AntdConfigProvider, { ...restContext, prefixCls: getPrefixCls('', customizePrefixCls) },
        React.createElement(Base, { ...otherProps, className: className, component: 'div', prefixCls: 'b-design' })));
};
export default Subtitle;
// export default withConfigProvider(Subtitle);
